module.exports = __webpack_public_path__ + "static/icon-1-yellow-849640e00c6185fdd20342efdcb747b2.png";